export const lineNetworkVertexShader = `
#define PI 3.1415926538
uniform float amplitude;
uniform float posZ;
uniform float mode;
uniform float animationDelta;
uniform float lerpPercent;
uniform vec3 origin;
uniform vec3 direction;
uniform float isInteracting;

attribute vec3 displacement;
attribute vec3 customColor;

attribute float myIndex;
attribute vec3 mode0PosInit;
attribute float mode0Radius;
attribute vec3 mode0Centroid;
attribute float mode0Speed;
attribute float mode0DeltaStart;

attribute vec3 mode2PosInit;

varying vec3 vColor;
varying float vOpacity;
varying float distToCamera;

vec3 v3PosNow;

float modI(float a,float b) {
	//a - (b * floor(a/b))
	return a - (b * floor(a/b));
    //float m=a-floor((a+0.5)/b)*b;
    //return floor(m+0.5);
}

vec3 findClosestPoint(vec3 v3Pos) {
    
	vec3 target = v3Pos - origin;
	float distance = dot(target, direction);
	return direction * distance + origin;

}

void main() {
	vec3 posMultiplier = vec3(1.0,1.0,posZ);
	vec3 newPosition = (position * posMultiplier);
	vec4 cs_position = modelViewMatrix * vec4(position,1.0);
    distToCamera = length(cs_position.xyz);

	///////////

	float deltaAdd = (animationDelta * 0.005 * (PI*2.0) * mode0Speed) + mode0DeltaStart;
	
	float modPos = modI(myIndex,3.0);
	vec3 m0Centroid = mode0Centroid;
	if(modPos == 0.0){
		v3PosNow = m0Centroid + vec3(  (sin(deltaAdd) * cos(mode0Radius)) * mode0Radius,(sin(deltaAdd) * sin(mode0Radius)) * mode0Radius,  cos(deltaAdd) * mode0Radius );
	}
	if(modPos == 1.0){
		v3PosNow = m0Centroid + vec3(cos(deltaAdd) * mode0Radius ,  (sin(deltaAdd) * sin(mode0Radius)) * mode0Radius,(sin(deltaAdd) * cos(mode0Radius)) * mode0Radius);
	}
	if(modPos == 2.0){
		v3PosNow = m0Centroid + vec3(  (sin(deltaAdd) * sin(mode0Radius)) * mode0Radius,(sin(deltaAdd) * cos(mode0Radius)) * mode0Radius,  cos(deltaAdd) * mode0Radius );
	
	}
	//vColor = customColor;
	
	
	newPosition = mix(v3PosNow,position,lerpPercent);

	
	////////////

	if(mode == 1.0){
		newPosition = mix(position,mode2PosInit,lerpPercent);
	}
	vColor = customColor;
	vec4 mvPosition = modelViewMatrix * vec4( newPosition, 1.0 );
	    
	if(isInteracting > 0.1){
		vec3 unprojectedPos = newPosition;
	    vec3 cp2p = findClosestPoint(unprojectedPos.xyz);
	    float distLen = length(unprojectedPos.xyz - cp2p);
	    if (distLen < 40.0){
	    	vColor *= (vec3(0.0,160.0/255.0,254.0/255.0));
	    	mvPosition = mix((modelViewMatrix * vec4(cp2p,1.0)),mvPosition,distLen / 40.0);
	    }
	}


	vOpacity = posZ;

	gl_Position = projectionMatrix * mvPosition;

}
`